








































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiMaterialAdd, apiMaterialEdit, apiMaterialDetail, apiMaterialCategoryList, apiSupplierList } from '@/api/material'
import MaterialSelect from '@/components/material-select/index.vue'

@Component({
  components: {
    MaterialSelect
  }
})
export default class MaterialRelease extends Vue {
    materialForm: any = {
      material_name: '',
      material_no: '',
      material_code: '',
      category_id: '',
      brand: '',
      specification: '',
      model: '',
      unit: '',
      material_type: 1,
      stock: 0,
      suggested_supplier_id: '',
      last_purchase_price: 0,
      retail_price: 0,
      image_urls: [],
      description: '',
      material_status: 1,
      // 其他字段
      weight: 0,
      volume: 0,
      color: '',
      size: '',
      unit_conversion: 1.000,
      conversion_unit: '',
      // 二维码
      qr_code: '',
      qr_code_image: ''
    }

    rules = {
      material_name: [
        { required: true, message: '请输入物料名称', trigger: 'blur' },
        { max: 200, message: '物料名称不能超过200个字符', trigger: 'blur' }
      ],
      material_no: [
        { required: true, message: '物料编号不能为空', trigger: 'blur' },
        { max: 50, message: '物料编号不能超过50个字符', trigger: 'blur' }
      ],
      category_id: [
        { required: true, message: '请选择物料分类', trigger: 'change' }
      ],
      unit: [
        { required: true, message: '请输入单位', trigger: 'blur' },
        { max: 20, message: '单位不能超过20个字符', trigger: 'blur' }
      ],
      material_type: [
        { required: true, message: '请选择物料类型', trigger: 'change' }
      ],
      material_status: [
        { required: true, message: '请选择物料状态', trigger: 'change' }
      ],
      stock: [
        { type: 'number', min: 0, message: '库存不能小于0', trigger: 'blur' }
      ],
      retail_price: [
        { type: 'number', min: 0, message: '零售价不能小于0', trigger: 'blur' }
      ],
      image_urls: [
        { required: true, message: '请上传物料图片', trigger: 'change' }
      ]
    }

    // Tab配置
    tabs = ['basic', 'price']
    activeTab = 'basic'
    loading = false
    categoryList: any[] = []
    supplierList: any[] = []

    get isEdit () {
      return this.$route.query.id
    }

    get alertTitle () {
      return this.isEdit
        ? '温馨提示：编辑物料信息，修改后会影响相关库存和采购数据。'
        : '温馨提示：新增物料需要完善基本信息、库存信息、价格信息、采购信息等内容。'
    }

    // 下一步
    handleNext () {
      this.validateCurrentTab().then((valid: boolean) => {
        if (valid) {
          const currentIndex = this.tabs.indexOf(this.activeTab)
          if (currentIndex < this.tabs.length - 1) {
            this.activeTab = this.tabs[currentIndex + 1]
          }
        }
      })
    }

    // 上一步
    handlePrev () {
      const currentIndex = this.tabs.indexOf(this.activeTab)
      if (currentIndex > 0) {
        this.activeTab = this.tabs[currentIndex - 1]
      }
    }

    // 验证当前tab的表单
    validateCurrentTab (): Promise<boolean> {
      return new Promise((resolve) => {
        let fieldsToValidate: string[] = []

        switch (this.activeTab) {
          case 'basic':
            fieldsToValidate = ['material_name', 'material_no', 'category_id', 'unit', 'material_type', 'material_status', 'image_urls']
            break
          case 'price':
            fieldsToValidate = ['retail_price']
            break
        }

        if (fieldsToValidate.length === 0) {
          resolve(true)
          return
        }

        (this.$refs.materialForm as any).validate((valid: boolean) => {
          if (valid) {
            resolve(true)
          } else {
            const errorElements = document.getElementsByClassName('el-form-item__error')
            if (errorElements.length > 0) {
              errorElements[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
            resolve(false)
          }
        })
      })
    }

    handleMaterialTypeChange (value: number) {
      // 物料类型变更处理逻辑
      // 已移除批次管理和序列号管理相关字段
    }

    handleSubmit () {
      this.validateCurrentTab().then((valid: boolean) => {
        if (valid) {
          this.loading = true
          const api = this.isEdit ? apiMaterialEdit : apiMaterialAdd
          const params = this.isEdit
            ? { id: this.$route.query.id, ...this.materialForm }
            : this.materialForm

          api(params).then(() => {
            this.$router.push('/material/inventory/lists')
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }

    getMaterialDetail () {
      if (this.isEdit) {
        apiMaterialDetail({ id: this.$route.query.id }).then((res: any) => {
          const data = res || {}
          Object.keys(this.materialForm).forEach(key => {
            if (data[key] !== undefined) {
              this.materialForm[key] = data[key]
            }
          })

          // 加载图片
          if (data.image_urls && data.image_urls.length > 0) {
            this.materialForm.image_urls = data.image_urls
          }
        })
      }
    }

    getCategoryList () {
      apiMaterialCategoryList().then((res: any) => {
        this.categoryList = res?.lists || []
      })
    }

    getSupplierList () {
      apiSupplierList({}).then((res: any) => {
        this.supplierList = res?.lists || []
      })
    }

    created () {
      this.getCategoryList()
      this.getSupplierList()
      this.getMaterialDetail()

      if (!this.isEdit) {
        // 生成物料编号：M+日期+随机数
        const date = new Date()
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
        this.materialForm.material_no = `M${year}${month}${day}${random}`
      }
    }
}
